import { render, staticRenderFns } from "./ModalBasicInfo.vue?vue&type=template&id=84732236&scoped=true"
import script from "./ModalBasicInfo.vue?vue&type=script&lang=js"
export * from "./ModalBasicInfo.vue?vue&type=script&lang=js"
import style0 from "./ModalBasicInfo.vue?vue&type=style&index=0&id=84732236&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84732236",
  null
  
)

export default component.exports